
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/smartphone",
      function () {
        return require("private-next-pages/smartphone/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/smartphone"])
      });
    }
  